import { useEffect, useState } from 'react'
import axios from 'axios';
import useConfirm from '../../../hooks/useConfirm';
import useModalStore from '../../../zustand/store/useModalStore';
import EmogPopup from './Emog_popup';

import {NoticeIco16} from '../../../images/icons/icons_component';

const JoinStep3 = ({setLoginStep, joinInfo}) => {
    const [formData, setFormData] = useState({
        userId: '',
        userPassword: '',
        reUserPassword: '',
        userIdConfirm: '',
        userIdChk: '',
        username: '',
        useripin: '',
        emogcode: '',
        emogdesc: '',
        authcode: ''
    });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleSelectEmog = (emog) => {
        setFormData((prev) => ({
            ...prev,
            emogcode: emog.emogcode,
            emogdesc: emog.emogdesc,
            authcode: emog.authcode
        }))
    };
    
    const { userName, userIpinDi, userIpinCi, userCertDate } = joinInfo || {};

    const idReg = /^[a-z0-9_-]{4,10}$/;
    const passwordReg1 = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{9,}$/;
    const passwordReg2 = /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{10,}$/;
    const passwordReg3 = /^(?=.*?[a-zA-Z])(?=.*?[#?!@$%^&*-]).{10,}$/;
    const passwordReg4 = /^(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,}$/;

    // confirm hook
    const confirm = useConfirm();
    const showNotiModal = useModalStore(state => state.showNotiModal);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...formData,
            [name]: value
        };
        setFormData(newParams);
    };

    const handleNext = async () => {
        try {
            if (!formData.userIdChk) {
                showNotiModal('아이디 중복확인을 진행해주세요.');
                return false;
            }
            if (!passwordReg1.test(formData.userPassword)
                && !passwordReg2.test(formData.userPassword)
                && !passwordReg3.test(formData.userPassword)
                && !passwordReg4.test(formData.userPassword)
                && !passwordReg1.test(formData.reUserPassword)
                && !passwordReg2.test(formData.reUserPassword)
                && !passwordReg3.test(formData.reUserPassword)
                && !passwordReg4.test(formData.reUserPassword)
            ) {
                showNotiModal('비밀번호는 영어 대/소문자, 숫자, 특수문자 모두를 조합한 9자리\n또는 2개를 조합한 10자리로 등록가능합니다.\n다시 입력해 주시기 바랍니다.');
                return false;
            }

            if (formData.userPassword != formData.reUserPassword) {
                showNotiModal('비밀번호 재확인 정보가 일치하지 않습니다.\n 다시 입력해 주시기 바랍니다.');
                return false;
            }
            if (formData.emogdesc === '') {
                showNotiModal('소속기관은 필수입력정보입니다.');
                return false;
            }
            console.log(formData);
            
            const ok = await confirm('입력하신 정보로 회원가입 하시겠습니까?');
            if(!ok) return false;

            const response = await axios.get('/commonapi/member/insertMember.do',
                { params: formData }
            );
            console.log(response);
            console.log(response.rtnNo);
            if (1 == response.data.rtnNo) {
                showNotiModal('이미 회원으로 가입되어 있습니다.\n 당신의 기존 아이디는 ' + response.data.rtnId + '입니다.');
            } else if (2 == response.data.rtnNo) {
                showNotiModal('영어와 숫자, 특수문자를 조합한 9자리 이상 20자리 이하\n 생성규칙에 맞게 다시 입력해 주시기 바랍니다.');
            } else {
                // 성공시
                setLoginStep(4);
            }
        } catch (e) {
            console.error('오류 발생', e);
        }
    };

    const handleIdChange = () => {
        setFormData((prev) => ({
            ...prev,
            userIdChk: false
        }))
    }

    const handleIntgIdCheck = async () => {
        if (!formData.userId || !idReg.test(formData.userId)) {
            showNotiModal('영어 소문자,숫자 또는 영어 소문자와 숫자를 조합한 4자리 이상 10자리 이하의\n 생성규칙에 맞게 다시 입력해 주시기 바랍니다.');
            setFormData((prev) => ({
                ...prev,
                userId: '',
                userIdChk: false
            }));
            return;
        }

        try {
            console.log(formData.userId);
            const response = await axios.post('/commonapi/member/selectIntgIdCheck.do',
                { userId: String(formData.userId) },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            )

            console.log(response.data);
            if (response.data.isExist) {
                showNotiModal('사용 불가능한 아이디입니다.\n 다시 입력해주시기 바랍니다.');
                setFormData((prev) => ({
                    ...prev,
                    userId: '',
                    userIdChk: false,
                    userIdConfirm: prev.userId
                }));
            } else {
                setFormData((prev) => ({
                    ...prev,
                    userIdChk: true,
                    userIdConfirm: prev.userId
                }));
                showNotiModal('사용 가능한 아이디입니다.');
            }
            return;
        } catch (error) {
            showNotiModal('[중복체크] 처리도중 오류가 발생하였습니다.');
        }
    };

    const handleCancel = async () => {
        if(formData.userIdChk || formData.userId.length > 4 || formData.userPassword > 0 || formData.emogdesc !== '') {
            const ok = await confirm('작성한 내용이 모두 초기화 됩니다.\n 이전 페이지로 돌아가시겠습니까?');
            if(!ok) return false;
        }
        setLoginStep(2);
    };

    useEffect(() => {
        const handler = (event) => {
            const selectEmog = event.data;
            if (selectEmog && selectEmog.emogcode) {
                setFormData((prev) => ({
                    ...prev,
                    emogcode: selectEmog.emogcode,
                    emogdesc: selectEmog.emogdesc,
                    authcode: selectEmog.authcode
                }));

            }
        };

        window.addEventListener('message', handler);
        return () => {
            window.removeEventListener('message', handler);
        };
    }, []);

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            username: userName,
            useripin: userIpinDi
        }));

    }, [userName, userIpinDi])

    return (
        <div className='join_contents'>
            <div className='flex flex-col gap-5'>
                <hr/>
                <div className='join_wrapper flex flex-col'>
                    <div className='flex justify-between'>
                        <h4>1. 기본정보</h4>
                        <p className='co_dark text-xs'>
                            <span className='co_red'>*</span> 는 반드시 입력이 필요한 필수 항목입니다.
                        </p>
                    </div>
                    <hr className='border-t-2 co_border_black'/>
                    <table>
                        <tbody>
                            <tr>
                                <th>아이디<span>*</span></th>
                                <td>
                                    <div className='flex gap-2 items-center'>
                                        <input type='text' className='join_input' id='userId' name='userId' value={formData.userId} onChange={handleInputChange} maxLength={10} title='아이디' disabled={formData.userIdChk ? true : false} />
                                        <button id='btnDupChk' onClick={formData.userIdChk ? handleIdChange : handleIntgIdCheck} className='excel_form_down co_dark' title='중복확인'>&nbsp;{formData.userIdChk ? '아이디 변경' : '중복확인'}</button>
                                        <span>※ 영어 소문자, 숫자 또는 영어소문자와 숫자를 조합한 4자리 이상 10자리 이하</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>비밀번호<span>*</span></th>
                                <td>
                                    <div className='flex gap-2 items-center'>
                                        <input type='password' className='join_input' id='userPassword' name='userPassword' value={formData.userPassword} onChange={handleInputChange} maxLength={20} title='비밀번호' />
                                        <span>※ 영문, 숫자, 특수문자 중 2종류 이상 조합 최소 10자리 또는 3종류 이상 조합 최소 9자리</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>비밀번호 확인<span>*</span></th>
                                <td>
                                    <div className='flex gap-2 items-center'>
                                        <input type='password' className='join_input' id='reUserPassword' name='reUserPassword' value={formData.reUserPassword} onChange={handleInputChange} maxLength={20} title='비밀번호 확인' />
                                        {formData.userPassword.length > 0 && formData.reUserPassword.length > 0 && formData.userPassword !== formData.reUserPassword &&
                                            <p className='flex items-center gap-1'>
                                                <NoticeIco16/>비밀번호가 일치하지 않습니다.
                                            </p>
                                        }
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>성명</th>
                                <td>
                                    <input type='hidden' id='username' name='username' value={userName} />
                                    {userName}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='join_wrapper'>
                    <h4>2. 추가입력정보</h4>
                    <hr className='border-t-2 co_border_black'/>
                    <table>
                        <tbody>
                            <tr>
                                <th>소속기관<span>*</span></th>
                                <td>
                                    <div className='flex gap-2 items-center'>
                                        <input type='hidden' value='' id='emogcode' name='emogcode' readonly='readonly' />
                                        <input type='hidden' value={formData.authcode} id='authcode' name='authcode' readonly='readonly' />
                                        <input className='join_input cursor-default' type='text' onClick={() => setIsModalOpen(true)} value={formData.emogdesc} id='emogdesc' name='emogdesc' readonly='readonly' title='소속기관' placeholder='기관검색으로 소속기관 입력' />
                                        <button id='btnPstinst' onClick={() => setIsModalOpen(true)} className='excel_form_down co_dark' title='새창-기관검색'>&nbsp;기관검색</button>
                                        {isModalOpen && (
                                            <EmogPopup
                                                onClose={() => setIsModalOpen(false)} // 닫기 버튼
                                                onSelect={handleSelectEmog}           // 선택 시 처리
                                            />
                                        )}
                                        <span>※ 소속기관이 없는 경우 가입이 불가합니다(응급의료기관 및 관련 유관기관만 가입 가능)</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <hr />
                <div className='comm_btn_box h-12'>
                    <button className='comm_btn_w w-40' onClick={handleCancel} id='btnCancel' title='뒤로'>뒤로</button>
                    <button className='comm_btn bg_co_black w-40' onClick={handleNext} id='btnNext' title='다음'>다음</button>
                </div>
            </div>
        </div>
    )
}

export default JoinStep3;